export type RuntimeConfig = {
  VITE_AZURE_B2C_TENANT_NAME: string;
  VITE_AZURE_B2C_CLIENT_ID: string;
  SIGN_IN_SIGN_UP_FLOW: string;
};

let config: RuntimeConfig | null = null;

export function setRuntimeConfig(c: RuntimeConfig) {
  config = c;
}

export function getRuntimeConfig(): RuntimeConfig {
  if (!config) {
    throw new Error('Runtime config not initialized');
  }
  return config;
}
